import '../css/app.pcss';
import '../js/slider';
import '../js/blog-image-slider';
import 'lazysizes';
import './fancybox';
import './accordian';
import './team-members';
import './banner-scroller';
import './mobileMenu';
import { handleMobileAnchorLinks, handleScrollOffsetLinks, initHeaderHeightVar } from './utils';
import { initStickySubNav } from './sticky-sub-nav';

// Initialize mobile anchor links with header offset after DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  initHeaderHeightVar();
  handleMobileAnchorLinks();
  handleScrollOffsetLinks();
  initStickySubNav();
});

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}